import React from 'react';
import { Users, Shield, DollarSign } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';

const WhyUsSection = () => {
  const features = [
    {
      icon: Users,
      title: 'Fast, human support',
      description: 'You get a real person who knows your environment—not a random call center.',
      color: 'from-blue-500 to-blue-600',
    },
    {
      icon: Shield,
      title: 'Security-first by default',
      description: 'We baseline devices, accounts, and Microsoft 365 to reduce risk and prevent downtime.',
      color: 'from-cyan-400 to-cyan-500',
    },
    {
      icon: DollarSign,
      title: 'Clear scope + predictable pricing',
      description: 'No mystery billing. Clear packages, clear deliverables, clear next steps.',
      color: 'from-blue-500 to-blue-600',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold text-cyan-500 uppercase tracking-wide mb-2">
            Why Us
          </p>
          <h2 className="text-4xl font-bold text-gray-900">
            Why MicroSystems Networking
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <Card
                key={index}
                className="border border-gray-200 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
              >
                <CardHeader>
                  <div className={`w-14 h-14 bg-gradient-to-br ${feature.color} rounded-xl flex items-center justify-center mb-4`}>
                    <Icon className="w-7 h-7 text-white" />
                  </div>
                  <CardTitle className="text-xl font-bold text-gray-900">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-gray-600 text-base leading-relaxed">
                    {feature.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;